import { createHttpService } from '../../../../../submodules/web-shared/services/http-service/http-service-factory';
import { PublicHttpServiceConfigurator } from './public-http-service-configurator';

export const publicHttpService = createHttpService(new PublicHttpServiceConfigurator());

